import React from "react";
import { Formik } from "formik";

export default function Form(props) {
  const { initialValues, validationSchema, handleSubmit, renderForm } = props;
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        handleSubmit(values);
       
      }}
    >
      {({ errors, touched }) => renderForm(errors, touched)}
    </Formik>
  );
}

